export var FontSizes = {
  H1: 36,
  H2: 24,
  H3: 18,
  H4: 16,
  H5: 16,
  H6: 16,
  BODY: 14,
  SMALL: 12,
  Large: {
    H1: 56,
    H2: 32,
    H3: 20
  }
};
export var FontWeights = {
  REGULAR: 400,
  MEDIUM: 600,
  BOLD: 700
};
export var fontFamilySansSerif = "\nfont-family: 'gordita', sans-serif, -apple-system, BlinkMacSystemFont;\n";